import { $ } from "./utils";
import { defer } from "lodash";

(() => {
  document.addEventListener("DOMContentLoaded", () => {
    // Navigation bar toggle and pin
    // -------------------------------------------------------------------------
    const $html = $("html");
    const toggleClass = "nav-open";

    const toggleNav = () => {
      window.scrollTo(0, 0);
      defer(() => $html.classList.toggle(toggleClass));
    };

    $(".js-nav-toggle").addEventListener("click", toggleNav);
  });
})();
